import { berachain as bera } from '@0xtorch/core'
import { berachain } from 'viem/chains'
import { type Client, createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createEtherscanV2 } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createBerachain = ({
  explorerApiKey: apiKey,
  explorerProxyUrl: proxyUrl,
  explorerPageSize: pageSize,
}: {
  explorerApiKey?: string
  explorerProxyUrl?: string
  explorerPageSize?: number
}) =>
  createBerachainCustom({
    client: createClient({
      chain: berachain,
      httpRpcs: berachainHttpRpcs,
    }),
    explorer: createEtherscanV2({
      name: 'BeraScan',
      baseUrl: 'https://berascan.com',
      chainId: 80_094,
      apiKey,
      proxyUrl,
      pageSize,
    }),
  })

type CreateBerachainParameters = {
  client: Client
  explorer: Explorer
}

export const createBerachainCustom = ({
  client,
  explorer,
}: CreateBerachainParameters): Chain => ({
  id: 80_094,
  network: 'berachain',
  name: 'Berachain',
  nativeToken: {
    name: 'Berachain',
    symbol: 'BERA',
    decimals: 18,
    currency: bera,
  },
  wrappedTokenAddresses: new Set([
    '0x6969696969696969696969696969696969696969',
  ]),
  explorer,
  client,
  blockTime: undefined,
  coingeckoId: 'berachain',
  defillamaId: undefined,
})

export const berachainHttpRpcs: HttpRpc[] = [
  {
    url: 'https://rpc.berachain.com',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  // {
  //   url: 'https://berachain.blockpi.network/v1/rpc/public',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 5000n,
  // },
  // {
  //   url: 'https://berachain-rpc.publicnode.com',
  //   getLogsIsUsable: false,
  //   getLogsMaxBlockRange: 0n,
  // },
  {
    url: 'https://berachain.drpc.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  // Not archiving receipts
  // {
  //   url: 'https://rpc.berachain-apis.com',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  {
    url: 'https://berachain-mainnet.gateway.tatum.io/',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
]

export const berachainWebsocketRpcUrls: readonly string[] = [
  'wss://berachain.drpc.org',
  'wss://rpc.berachain-apis.com',
]
